/* RESPONSIBLE TEAM: team-inbox */
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type Token from 'embercom/models/custom-authentication/token';

interface CustomActionModel {
  action: any;
  objectTypes: any;
  conversationAtributes: any;
  actionLogs: any[];
  ticketTypes: any;
  customAuthenticationTokens: Token[];
  loadNextPage: any;
  updateFilters: any;
}

export default class CustomActionController extends Controller {
  declare model: CustomActionModel;

  queryParams = ['selectedTab', 'actionExecutionResultId'];

  @tracked selectedTab = 'general_section';
  @tracked actionExecutionResultId: number | null = null;

  @action
  changeTab(tab: string) {
    this.selectedTab = tab;
  }
}
